import withLgpdCookie from './withLgpdCookie';

export default withLgpdCookie;
